/* eslint-disable global-require */
import React from 'react';
// import PropTypes from 'prop-types';

import Article from '../Article';

const classNames = require('classnames');

const Level = () => {
  const className = classNames({
    level: true
  });

  return (
    <div className={className}>
      <div className="level__content" style={{ width: '100%' }}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <Article center>
                <header className="article__header">
                  <h2>Level 3 – Proctortrack QA</h2>
                </header>
                <section className="article__section">
                  <p>
                    Highest Accuracy Fidelity Report within 12-24 Hours.
                    <br />
                    <strong>Ideal for Midterm & Finals.</strong>
                  </p>
                </section>
              </Article>
            </div>
          </div>
          <div className="inner">
            <table>
              <tr>
                <th>1. Veripass Onboarding</th>
                <th>
                  <img alt="" src={require('./tick.png')} />
                </th>
              </tr>
              <tr>
                <td>2. Identity Verification</td>
                <td>
                  <img alt="" src={require('./tick.png')} />
                </td>
              </tr>
              <tr>
                <th>3. System Check</th>
                <th>
                  <img alt="" src={require('./tick.png')} />
                </th>
              </tr>
              <tr>
                <td>4. Whitelisting apps</td>
                <td>
                  <img alt="" src={require('./tick.png')} />
                </td>
              </tr>
              <tr>
                <th>5. Browser lockdown</th>
                <th>
                  <img alt="" src={require('./tick.png')} />
                </th>
              </tr>
              <tr>
                <td>6. Instructor Review</td>
                <td>
                  <img alt="" src={require('./tick.png')} />
                </td>
              </tr>
              <tr>
                <th>7. Tech Support</th>
                <th>
                  <img alt="" src={require('./tick.png')} />
                </th>
              </tr>
              <tr>
                <td>
                  <span>8. Blacklisting apps</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>9. Virtual Machine Detections</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>10. Data Copy Attempt</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>11. Desktop Screen Capture</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>12. Attempted Print</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>13. Online Aid</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>14. Desktop Recording</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>15. User Recording</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>16. Imposter Violation</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>17. Multiple People</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>18. Left Session</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>19. Left Screen</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>20. User Desktop Screen Capture</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>21. Used Prohibited Device</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>
                  <span>22. Phone Call</span>
                </td>
                <td>
                  <img alt="" src={require('./red-tick.png')} />
                </td>
              </tr>
              <tr>
                <td>23. Facial Suspicion</td>
                <td>
                  <img alt="" src={require('./rec.png')} />
                </td>
              </tr>
              <tr>
                <td>24. Eating / Drinking</td>
                <td>
                  <img alt="" src={require('./rec.png')} />
                </td>
              </tr>
              <tr>
                <td>25. Background Audio</td>
                <td>
                  <img alt="" src={require('./rec.png')} />
                </td>
              </tr>
              <tr>
                <td>26. Background Motion</td>
                <td>
                  <img alt="" src={require('./rec.png')} />
                </td>
              </tr>
              <tr>
                <td>27. Room Too Dark</td>
                <td>
                  <img alt="" src={require('./rec.png')} />
                </td>
              </tr>
              <tr>
                <td>28. Video Not Clear</td>
                <td>
                  <img alt="" src={require('./rec.png')} />
                </td>
              </tr>
            </table>
            <div className="flex">
              <span>*BLUE = HIGH RISK</span>
              <p>• REC = RECORDED, NOT PROCESSED</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
Level.defaultProps = {};
Level.propTypes = {};
export default Level;
